module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('AbsentToday', {
    attrs: {
      "is-subs-today": false,
      "is-public": true
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-effc53f6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subs/OverviewTodayAbsentPublic.vue
// module id = 2156
// module chunks = 1